import { VettingApi } from "@/api/vetting";
import { RejectUserRequest } from "@/api/vetting/types/reject-user.types";
import { QueryKey, ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { useUIStore } from "@/stores";

export const useRejectUser = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: RejectUserRequest) => VettingApi.rejectUser(body),
    onError: (error) => {
      closeModal();
      notify(error, { type: "error" });
    },
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.USER, userId],
      });
      queryClient.invalidateQueries({
        queryKey: [ResourceName.VETTING_USERS],
      });
      closeModal();
      notify("User is rejected", { type: "success" });
    },
  });

  return {
    rejectUser: mutate,
    isRejectUserLoading: isPending,
  };
};
